export interface KalturaPlayerInitParams
  extends Readonly<{
    partnerId: string;
    subPartnerId: string;
    playerId: string;
  }> {}

export interface KalturaPlayerEmbedParams
  extends Readonly<{
    targetId: string;
    partnerId: string;
    playerId: string;
    cacheId: number;
    videoId: string;
  }> {}

export type KalturaPlayerVideoParams = Pick<KalturaPlayerEmbedParams, 'targetId' | 'cacheId' | 'videoId'>;

const setupKaltura = (params: KalturaPlayerInitParams) => {
  const { partnerId, subPartnerId, playerId } = params;

  const getInitScript = (): HTMLElement => {
    const playerScript = document.createElement('script');
    playerScript.type = 'text/javascript';
    playerScript.src = `https://cdnapisec.kaltura.com/p/${partnerId}/sp/${subPartnerId}/embedIframeJs/uiconf_id/${playerId}/partner_id/${partnerId}`;
    return playerScript;
  };

  return {
    getInitScript,
  };
};

/**
 * Initialize Kaltura player by injecting the required script to the document head
 * @param params The required params to initialize Kaltura player
 */
const init = (params: KalturaPlayerInitParams): void => {
  const kaltura = setupKaltura(params);

  const initScript = kaltura.getInitScript();

  document.head.insertBefore(initScript, document.head.childNodes[0]);
};

/**
 * Embed the Kaltura player according to the passed options
 * @param params The required params to embed Kaltura player
 */
const embedPlayer = (params: KalturaPlayerEmbedParams): void => {
  window.kWidget.embed({
    targetId: params.targetId,
    wid: `_${params.partnerId}`,
    uiconf_id: Number(params.playerId),
    flashvars: {},
    cache_st: params.cacheId,
    entry_id: params.videoId,
  });
};

/**
 * Destroy a previously embedded Kaltura player
 * @param targetId The container id of the embedded Kaltura player
 */
const destroyPlayer = (targetId: string): void => {
  window.kWidget.destroy(targetId);
};

export const KalturaPlayer = {
  init,
  embedPlayer,
  destroyPlayer,
};
